import React from "react";
import CaptchaProvider from "../Captcha/CaptchaProvider";
import RegistrationForm from "./RegistrationForm/RegistrationForm";

const Form = () => (
  <div id="middle-wizard">
    <CaptchaProvider>
      <RegistrationForm />
    </CaptchaProvider>
  </div>
);

export default Form;
